var site = site || {};

site.userInfoCookie = site.userInfoCookie || {};
site.userInfoCookie.getValue =
  site.userInfoCookie.getValue ||
  function () {
    return '';
  };
(function ($) {
  Drupal.behaviors.loyaltyJoinSigninV1 = {
    attach: function (context) {
      var signed_in = site.userInfoCookie.getValue('signed_in') - 0;
      var isLoyalty = site.userInfoCookie.getValue('is_loyalty_member') - 0;

      if (isLoyalty) {
        $('.non_loyalty_user_sticky_nav', context).hide();
      } else {
        $('.loyalty_user_sticky_nav', context).hide();
        if (signed_in) {
          $('.js-online_join_now_button', context).removeClass('hidden');
          $('.js-guest_join_now_button', context).addClass('hidden');
        }
      }
    }
  };
})(jQuery);
